'use strict';

var m = angular.module('ui.utils.masks.fr', [])
	.directive('uiFrPhoneNumberMask', require('./phone/fr-phone'));

module.exports = m.name;



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-input-masks/src/fr/fr-masks.js
 ** module id = 321
 ** module chunks = 1
 **/